import { useEffect } from 'react';
import { useNavigation } from 'react-router-dom';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// 配置 nprogress
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.08,
});

/**
 * RouterProgress — 在 React Router v7 路由切换时显示顶部进度条
 * 
 * 用法：放在 <BrowserRouter> 内部、<App> 内部任意位置（需在路由上下文内）
 * 通常在 <App> 或 Layout 中渲染一次即可。
 */
export default function RouterProgress() {
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === 'loading' || navigation.state === 'submitting') {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [navigation.state]);

  return null;
}
